var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadTrackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 97,
    viewBox: "0 0 87 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1289 15.4527L71.1289 0L86.4729 2.68282e-06L86.4729 0.0139729L71.1371 15.4523L71.1289 15.4527Z",
    fill: "#EABD5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4646 43.9208L71.1289 43.9208L71.1289 15.457L86.4646 30.8953L86.4646 43.9208Z",
    fill: "#456ABB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.146 15.4527L45.2754 15.4527L45.2754 0L55.8813 1.85439e-06L71.1464 15.3673L71.1464 15.4527L71.146 15.4527Z",
    fill: "#D57F2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4646 15.4539L71.1289 15.4539L86.4646 0.0156277L86.4646 15.4539Z",
    fill: "#6AA163"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4646 15.4601L86.4646 30.8984L71.1289 15.4601L86.4646 15.4601Z",
    fill: "#6990E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2163 15.4415L55.9512 0.0742188L71.2163 0.0742214L71.2163 15.4415Z",
    fill: "#ED9F39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2245 96.7379C13.9797 96.7379 0 82.7582 0 65.5134V0H24.7186V60.6034C24.7186 69.2258 31.7084 76.2156 40.3308 76.2156H85.4191V96.7379H31.2245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadTrackIcon);
export default __webpack_public_path__ + "static/media/LeadTrack-icon.aaf8edc1720616e19acfb8ecaf899c14.svg";
export { ForwardRef as ReactComponent };